module.exports = {
  appId: "B1A204F4-6A01-4FB3-8342-637618CF41F9",
};
